import { render } from "./NewDayCard.vue?vue&type=template&id=5415679e"
import script from "./NewDayCard.vue?vue&type=script&lang=js"
export * from "./NewDayCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__